<template>
  <div v-if="access !== null">
    <!-- <EditSyaratSOSPopup
      :activate="active"
      @callback="callBackPopUp"
      @withClose="loadData"
      :passData="passData"
      :kategoriList="kategoriList"
    /> -->
    <syarat-kumpul-popup
      v-if="passSyarat !== null"
      :activate="activeSyarat"
      @callback="callBackSyaratKumpul"
      @withClose="loadData"
      :passData="passSyarat"
    />
    <vx-card>
      <!-- TABLE ACTION ROW -->
      <header class="w-full">
        <div class="mb-base mt-4 vx-row justify-between items-top">
          <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
            <span class="text-black text-2xl">Tabel Syarat SOS</span>
          </section>
          <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end">
            <vs-button @click="openPopUp(null)" v-if="access.create === 1"
              >Tambah Syarat SOS</vs-button
            >
          </section>
        </div>
        <div class="vx-row justify-between items-center">
          <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
            <div class="w-full gap-2 flex justify-start items-center">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <vs-button icon-after icon="expand_more">Aksi</vs-button>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="dialogDelete" v-if="access.delete === 1">
                    <span>Hapus</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2">{{ `entries ${limit}` }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-for="(item, index) in limitDataTables"
                    :key="index"
                    @click="limit = item"
                  >
                    <span>{{ item }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </section>
          <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
            <div class="w-full flex justify-end gap-2 flex-wrap items-center">
              <v-select
                :options="kategoriList"
                :reduce="(v) => v.id"
                label="name"
                v-model="kat_id"
                placeholder="Pilih Kategori"
              />
              <v-select
                v-if="kat_id !== null"
                :options="subKategoriList"
                :reduce="(v) => v.id"
                label="name"
                v-model="sub_id"
                placeholder="Pilih Sub-Kategori"
              />
              <vs-input v-model="search" placeholder="Search..." />
            </div>
          </section>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div
          class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
        ></div>
      </header>

      <main ref="loadSyaratSOS">
        <vs-table
          stripe
          :data="syarats"
          v-model="selected"
          :max-items="limit"
          pagination
          multiple
        >
          <template slot="thead">
            <vs-th>Nama</vs-th>
            <vs-th>Deskripsi</vs-th>
            <vs-th>Sub-kategori SOS</vs-th>
            <vs-th>Aksi</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>
              <vs-td :data="data[indextr].deskripsi">
                {{ data[indextr].deskripsi }}
              </vs-td>
              <vs-td
                :data="
                  data[indextr].kategori !== null ? data[indextr].kategori.name : 'Null'
                "
              >
                {{
                  data[indextr].kategori !== null ? data[indextr].kategori.name : "Null"
                }}
              </vs-td>
              <vs-td>
                <div class="flex justify-start gap-2">
                  <vs-button
                    v-if="access.update === 1"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click="openPopUp(data[indextr])"
                  >
                  </vs-button>
                  <vs-button
                    color="warning"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-menu"
                    @click="openSyaratKumpul(data[indextr])"
                  >
                  </vs-button>
                  <vs-button
                    v-if="access.delete === 1"
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="dialogDelete(data[indextr].id, data[indextr].name)"
                  >
                  </vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </main>
    </vx-card>
  </div>
</template>

<script>
import EditSyaratSOSPopup from "@/views/sos/component/EditSyaratSOSPopup.vue";
import SyaratKumpulPopup from "@/views/sos/component/SyaratKumpulPopup.vue";
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";

export default {
  components: {
    EditSyaratSOSPopup,
    SyaratKumpulPopup,
  },
  computed: {
    filterParams() {
      return {
        sub_id: this.sub_id,
        search: this.search,
      };
    },
  },
  data() {
    return {
      emptyImage,
      params: {},
      kategoriList: [],
      subKategoriList: [],
      kat_id: null,
      sub_id: null,
      limitDataTables,
      limit: limitDataTables[0],
      active: false,
      activeSyarat: false,
      passData: null,
      passSyarat: null,
      selected: [],
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      syarats: [],
      access: null,
      search: "",
    };
  },
  watch: {
    search() {
      if (this.search !== "" || this.search !== null) {
        this.params = {
          search: this.search,
        };
      } else {
        this.params = {};
      }

      this.getData();
    },
    filterParams: {
      handler(v) {
        let search = {};
        let sub_id = {};

        if (v.search !== "" || v.search !== null) {
          search = {
            filter: "name",
            search: this.search,
          };
        } else {
          search = {};
        }

        if (v.sub_id !== null) {
          sub_id = {
            sub_id: this.sub_id,
          };
        } else {
          sub_id = {};
        }

        this.params = Object.assign(search, sub_id);
        this.getData();
      },
      deep: true,
    },
    kat_id() {
      if (this.kat_id !== null) {
        this.subKategoriList = this.$store.getters["sos/getFilteredSubKategori"](
          this.kat_id
        );
      }
    },
  },
  methods: {
    callBackPopUp(val) {
      this.active = val;
      this.passData = null;
    },
    callBackSyaratKumpul(val) {
      this.activeSyarat = val;
      this.passSyarat = null;
    },
    loadData(val) {
      if (val) {
        this.getData();
      }
    },
    openPopUp(item) {
      this.active = true;
      this.passData = item;
    },
    openSyaratKumpul(item) {
      this.activeSyarat = true;
      this.passSyarat = item;
    },
    getKategoriSOS() {
      this.$store
        .dispatch("sos/getKategoriSOS", {})
        .then((v) => {
          this.kategoriList = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getSubKategoriSOS() {
      this.$store
        .dispatch("sos/getSubKategoriSOS", {})
        .then((v) => {
          this.subKategoriList = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    dialogDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
        text:
          name && id
            ? `Anda yakin ingin menghapus item ${name}`
            : "Anda yakin ingin menghapus item yang terpilih",
        accept: () => {
          if (name && id) {
            this.delete(id);
          } else {
            // eslint-disable-next-line no-lonely-if
            if (this.selected.length === 0) {
              this.$vs.notify({
                title: "Tidak ada item yang dipilih",
                text: "Pilihlah salah satu item atau semua item",
                color: "danger",
                position: "top-right",
              });
            } else {
              // eslint-disable-next-line prefer-const
              for (let i in this.selected) {
                this.delete(this.selected[i].id);
              }
            }
          }
        },
      });
    },
    delete(id) {
      this.$vs.loading({
        container: this.$refs.loadSyaratSOS,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("sos/cudSyaratSOS", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadSyaratSOS);
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Syarat SOS ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadSyaratSOS);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadSyaratSOS,
        color: "primary",
      });
      this.$store
        .dispatch("sos/getSyaratSOS", this.params)
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadSyaratSOS);
          this.syarats = v.data;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadSyaratSOS);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  mounted() {
    this.getData();
    if (this.$store.state.sos.kategoriSOSList.length === 0) {
      this.getKategoriSOS();
    } else {
      this.kategoriList = this.$store.state.sos.kategoriSOSList;
    }

    if (this.$store.state.sos.subKategoriSOSList.length === 0) {
      this.getSubKategoriSOS();
    } else {
      this.subKategoriList = this.$store.state.sos.subKategoriSOSList;
    }
  },
  created() {
    if (this.$store.state.auth.profileAccess !== null) {
      if (
        this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/syarat-sos"
        )
      ) {
        this.access = this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/syarat-sos"
        );
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.text-blue {
  color: blue;
}
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
